import React, { isValidElement } from "react";
import { type ItemSlotType } from "../types";

export const ItemSlot = ({ slot, className = "", textColor = "" }: ItemSlotType) => {
  if (slot === undefined || slot === null) return null;
  return (
    <div
      className={`cui__item-slot cui-flex cui-items-center ${textColor} ${className}`.trim()}
    >
      {slot}
    </div>
  );
};

ItemSlot.displayName = "ItemSlot";
